/**
 * v0.8.48 — Named floating-point tolerance constants.
 *
 * Prior state: `0.001`, `0.005`, and `0.01` appeared as bare magic
 * numbers across 8 sites in the engine + store. The audit called it
 * out as drift risk. The right fix isn't to unify to a single value
 * (the three semantics ARE distinct), but to name them so the choice
 * is visible and the semantic is explicit at each call site.
 *
 * The three semantics:
 *
 *   PAID_OFF_TOLERANCE (0.005 — half a cent)
 *     "How close to zero counts as paid off for display / storage."
 *     Applied to `debt.balance` and to close-month ending balances.
 *     Half-cent because balances in the app are dollar-and-cents; a
 *     residue smaller than half a cent rounds to $0.00 in every UI
 *     surface anyway.
 *
 *   MIN_PAYMENT_TOLERANCE (0.005 — half a cent)
 *     "How close to the required minimum counts as 'paid on time' for
 *     the due-dates checklist." Was 0.001 pre-v0.8.48 (10x tighter
 *     than adjacent surfaces); brought in line with PAID_OFF_TOLERANCE
 *     so the whole app has a consistent "close enough to zero" bar.
 *
 *   SIMULATION_CLEARED_THRESHOLD (0.01 — one cent)
 *     "Loop-termination bound for the payoff simulation." Different
 *     semantic entirely: the simulation runs month by month with
 *     interest accrual, so a debt whose remaining balance drops below
 *     a cent gets treated as cleared to break the loop cleanly.
 *     Slightly looser than PAID_OFF_TOLERANCE because interest
 *     computations can leave sub-cent residue that would otherwise
 *     drag the simulation on for extra months.
 */

export const PAID_OFF_TOLERANCE = 0.005
export const MIN_PAYMENT_TOLERANCE = 0.005
export const SIMULATION_CLEARED_THRESHOLD = 0.01
